import i18n from 'src/i18n';

const configTable = () => ({
  tableColumns: [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'depth',
      label: i18n.t('common_words.depth'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'valve.name',
      label: i18n.t('common_words.valve'),
      minWidth: 120,
      sortable: true,
    },
  ],
});

export default configTable;
